import { JourneyPicker } from '@features/JourneyPicker';
import { OnChangeParams, TrackGaUpdateBtnFn } from '@features/JourneyPicker/JourneyPicker.types';
import { FC } from 'react';
import { JourneyParams } from 'shared-types/Common';
import { RoomRateAvailability } from 'shared-types/Room';

type DatesPickerProps = {
  journeyParams: JourneyParams;
  onChangeJourneyParams: (params: OnChangeParams) => void;
  availability?: RoomRateAvailability;
  rateCode?: string;
  showGuestsPicker?: boolean;
  trackGaUpdate?: TrackGaUpdateBtnFn;
};

export const DatesPicker: FC<DatesPickerProps> = ({
  journeyParams,
  onChangeJourneyParams,
  rateCode,
  showGuestsPicker,
  trackGaUpdate,
}) => (
  <JourneyPicker
    trackGaUpdate={trackGaUpdate}
    journeyParams={journeyParams}
    showGuestsPicker={showGuestsPicker}
    onChange={onChangeJourneyParams}
    rateCode={rateCode}
  />
);
